module.exports = __webpack_public_path__ + "static/slack-news-webhook-f8ecab5b987340aebaef9e691686b407.png";